const sendAnalytic = (category, action, label = '') => {
    const tracker = typeof window !== 'undefined' ? window._piq : null;

    if (Array.isArray(tracker)) {
        tracker.push(['trackEvent', category, action, label]);
    }

    if (typeof Image === 'undefined') {
        return;
    }

    const image = new Image();
    const now = Math.floor(Date.now() / 1000);
    const year = '2023';
    const group = '2023pinkyouthkeeper';

    image.src = `/pei.gif?year=${year}&group=${group}&url=${encodeURIComponent(label)}&t=${now}`;
};

export default sendAnalytic;
